// extracted by mini-css-extract-plugin
export default {"number":"HotWalletDetailsTableView_number__o5KPR","tableWrapper":"HotWalletDetailsTableView_tableWrapper__OTjVu","checkedStatus":"HotWalletDetailsTableView_checkedStatus__hDcGr"};